<template>
  <div :id="id" class="text-input">
    <input
      v-if="editEnabled"
      ref="textEditor"
      v-model="editedValue"
      class="text-editor"
      type="text"
      @keyup.enter="submitValue"
      @blur="submitValue"
    >
    <div
      v-else
      class="text-preview"
    >
      {{ value }}
      <img
        src="~@/assets/icon-pencil.svg"
        class="edit-button"
        @click="enableEdit"
      >
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import InputsMixin from './InputsMixin';

export default {
  name: 'TextInput',
  mixins: [
    InputsMixin,
  ],
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      editEnabled: false,
      editedValue: '',
    };
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.editedValue = this.value;
      },
    },
  },
  methods: {
    submitValue() {
      this.emitChangedValue(this.editedValue);
      this.editEnabled = false;
    },
    enableEdit() {
      this.editEnabled = true;
      Vue.nextTick(() => this.$refs.textEditor.focus());
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/variables";
@import "~@/assets/scss/inputs";

.text-input {
  display: flex;
  align-items: center;
  height: 44px;
  font-family: Lato;

  .text-editor {
    @extend %input;
    height: 100%;
    width: 100%;
    padding: 12px;
    font-size: $size-4;
    line-height: 21px;
    box-sizing: border-box;

    &:focus,
    &:active {
      background-color: $input-background-color;
      border-color: $input-border-color;
    }
  }

  .text-preview {
    display: flex;
    align-items: center;
    color: white;
    font-size: 25px;
    font-weight: $weight-bold;
    line-height: 30px;

    .edit-button {
      margin-left: 25px;
      cursor: pointer;
    }
  }
}
</style>
